import { render, staticRenderFns } from "./PaxAffected.vue?vue&type=template&id=383eac8f&scoped=true&"
import script from "./PaxAffected.vue?vue&type=script&lang=js&"
export * from "./PaxAffected.vue?vue&type=script&lang=js&"
import style0 from "./PaxAffected.vue?vue&type=style&index=0&id=383eac8f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383eac8f",
  null
  
)

export default component.exports